<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8382_28389)">
      <path
        d="M2.625 4.74996H4.04167M4.04167 4.74996H15.375M4.04167 4.74996L4.04167 14.6666C4.04167
        15.0423 4.19092 15.4027 4.4566 15.6684C4.72228 15.934 5.08261 16.0833 5.45833
        16.0833H12.5417C12.9174 16.0833 13.2777 15.934 13.5434 15.6684C13.8091 15.4027
        13.9583 15.0423 13.9583 14.6666V4.74996M6.16667 4.74996V3.33329C6.16667 2.95757
        6.31592 2.59723 6.5816 2.33156C6.84728 2.06588 7.20761 1.91663 7.58333
        1.91663H10.4167C10.7924 1.91663 11.1527 2.06588 11.4184 2.33156C11.6841 2.59723
        11.8333 2.95757 11.8333 3.33329V4.74996M7.58333 8.29163V12.5416M10.4167 8.29163V12.5416"
        stroke="#F7F8FD"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8382_28389">
        <rect
          width="17"
          height="17"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>